module.exports = __webpack_public_path__ + "static/leafy-zoom-7c5a9aeef1c50abd4278a875b4c29a7f.jpg";